import React from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'

const SupportModal = ({ showModal, handleClose, message }) => {
  const modalClose = () => {
    handleClose()
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        className='payment-modal'>
        <Modal.Header className='payment-modal-header d-flex justify-content-center'>
          <h3 className='payment-modal-title mb-0'>SUPPORT</h3>
        </Modal.Header>
        <Modal.Body className='payment-modal-body'>
          <div className='s7'>
            {message && <>{message} </>}
            If you have any questions or need support, feel free to contact us
            at{' '}
            <a
              href='mailto:experiences@abroad.io'
              className='text-saffron-700 text-decoration-none'>
              experiences@abroad.io
            </a>
            .{!message && <> We’ll get back to you within 24 hours.</>}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='secondary-light'
            onClick={modalClose}
            className='px-3 secondary-popup-button'
            size='sm'>
            Close{' '}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default SupportModal
